// import consts from "@/consts"
import {arrayFilter_OnlyUnique, getApiProps, calcSinceSyncedLast} from "@/lib/lib";
import i18n from "@/i18n";
import consts from "@/consts";

const changedField = 'changed__time';
const alertsTypes = ['alert'];

let _eventsIndexCache = {arr: null, map: null}
function getEventsIndexMap(state) {
    if (_eventsIndexCache.arr !== state.events) {
        _eventsIndexCache.map = new Map(state.events.map((e, i) => [e.xid, i]))
        _eventsIndexCache.arr = state.events
    }
    return _eventsIndexCache.map
}

export default {
    state: {
        events_index: [],
        events: [],
        lastVisitEvents: null,
        lastVisitAlerts: null,
    },
    actions: {
        fetchEvents({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchEvents', args, time: Date.now() / 1000})

                let params = getApiProps('events', {withAddress: 1, ...args})
                //if(!args.force) params.lastTimes = getters.getEventsLastTimeByUnitIds
                delete params.unitId;
                this.$api.events.getAll(args.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeEvents', response.data)
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchEvents', args, inprogress: false})
                    });
            })
        },
        fetchLastEvents({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                let sinceSynced = null
                if (args.last === 'since-synced') {
                    sinceSynced = calcSinceSyncedLast(getters.getEventsIndex, args.unitId, getters.getDateToday)
                    if (!sinceSynced) {
                        return resolve(true)
                    }
                    if (sinceSynced.reload) {
                        return dispatch('fetchEvents4Date', {unitId: args.unitId, date: 'today', force: true}).then(resolve, reject)
                    }
                    args = {...args, last: sinceSynced.last}
                } else
                if (args.unitId > 0 && !args.force) {
                    let index = getters.getEventsIndex.find(i => (i.unitId == args.unitId && i.date == getters.getDateToday))
                    if (!index) {
                        return resolve(true)
                    }
                }

                let startTime = Date.now() / 1000
                dispatch('setLastCall', {name: 'fetchLastEvents', args, time: Date.now() / 1000})
                dispatch('setLastCall', {name: 'fetchEventsChanged', args, time: Date.now() / 1000})

                let params = getApiProps('events', {withAddress: 1, ...args})
                //if(!args.force) params.lastTimes = getters.getEventsLastTimeByUnitIds
                delete params.unitId;delete params.last;
                this.$api.events.getLast(args.unitId, args.last, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeEvents', response.data)
                            if (sinceSynced) {
                                commit('setEventsIndex', {unitId: sinceSynced.entry.unitId, date: sinceSynced.entry.date, synced: startTime})
                            }
                            resolve(response)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchLastEvents', args, inprogress: false})
                        dispatch('setLastCall', {name: 'fetchEventsChanged', args, inprogress: false})
                    });
            })
        },
        fetchEvents4Date({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                args = {unitId: '', date: '', ...args}
                if (args.date == 'today' || !args.date) args.date = getters.getDateToday
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !(args.date > '')) {//!args.unitId ||
                    return reject(false)
                }

                if (args.unitId > 0 && !args.force) {
                    let index = getters.getEventsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                    if (index) {
                        return resolve(true)
                    }
                }

                let synced = Date.now() / 1000
                dispatch('setLastCall', {name: 'fetchEvents4Date', args, time: Date.now() / 1000})
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastEvents', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchEventsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('events', {withAddress: 1, ...args})
                delete params.unitId;delete params.date;
                this.$api.events.get4Date(args.unitId, args.date, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeEvents', response.data)
                            if (!params.limit || response.data.length < params.limit) {
                                commit('setEventsIndex', {...args, count: response.data.length, synced})
                                if (!args.unitId && response.data.length) {
                                    response.data
                                        .map(e => e.unit_id)
                                        .filter(arrayFilter_OnlyUnique)
                                        .forEach(unitId => {
                                            commit('setEventsIndex', {...args, unitId, count: 1, synced})
                                        })
                                }
                            }
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchEvents4Date', args, inprogress: false})
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastEvents', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchEventsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchEvents4Period({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                let isToday = (args.date == getters.getDateToday)
                if (!getters.getApiToken || !args.from || !args.to) {//!args.unitId ||
                    return reject(false)
                }

                // if (args.unitId > 0 && !args.force) {
                //     let index = getters.getEventsIndex.find(i => (i.unitId == args.unitId && i.date == args.date))
                //     if (index) {
                //         return resolve(true)
                //     }
                // }

                dispatch('setLastCall', {name: 'fetchEvents4Date', args, time: Date.now() / 1000})
                /* getters.getTimeToday+24h and args.from/to intersect*/
                if (isToday) {
                    dispatch('setLastCall', {name: 'fetchLastEvents', args, time: Date.now() / 1000})
                    dispatch('setLastCall', {name: 'fetchEventsChanged', args, time: Date.now() / 1000})
                }

                let params = getApiProps('events', {withAddress: 1, ...args})
                delete params.unitId;delete params.from;delete params.to;
                this.$api.events.get4Period(args.unitId, args.from, args.to, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeEvents', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchEvents4Date', args, inprogress: false})
                        /* getters.getTimeToday+24h and args.from/to intersect*/
                        if (isToday) {
                            dispatch('setLastCall', {name: 'fetchLastEvents', args, inprogress: false})
                            dispatch('setLastCall', {name: 'fetchEventsChanged', args, inprogress: false})
                        }
                    });
            })
        },
        fetchEventsLastSuccessful({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchEventsLastSuccessful', args, time: Date.now() / 1000})

                let params = getApiProps('events', {withAddress: 1, ...args})
                delete params.unitId;
                this.$api.events.getLastSuccessful(args.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('storeEvents', response.data)
                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchEventsLastSuccessful', args, inprogress: false})
                    });
            })
        },
        fetchEventsChanged({dispatch, getters}, args) {
            if (!getters.getApiToken) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchLastEvents', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchEventsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            delete args.date
            return dispatch('fetchEvents', args)
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchLastEvents', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchEventsChanged', args, inprogress: false})
                });
        },
        reloadEvents({commit, dispatch}, args) {
            commit('clearEvents')
            return dispatch('fetchEvents4Date', {date: 'today', ...args})
        },

        //sayHello() {}
    },
    mutations: {
        setEventsIndex(state, params) {
            let i = state.events_index.findIndex(i => i.date == params.date && i.unitId == params.unitId)
            if (i < 0) {
                state.events_index.push(Object.freeze({...params}))
            } else {
                state.events_index[i] = Object.freeze({...state.events_index[i], ...params})
            }
        },
        storeEvents(state, nEvents) {
            if (!state.events.length) {
                state.events = nEvents.map(e => Object.freeze(e))
                return true
            }

            const indexByXid = getEventsIndexMap(state)

            nEvents.forEach(function (nEvent) {
                let i = indexByXid.has(nEvent.xid) ? indexByXid.get(nEvent.xid) : -1
                if (i < 0) {
                    indexByXid.set(nEvent.xid, state.events.length)
                    state.events.push(Object.freeze(nEvent))
                } else
                if (state.events[i][changedField] != nEvent[changedField]) {
                    // updateObjectByDiff(state.events[i], nEvent)
                    delete nEvent.xid
                    state.events[i] = Object.freeze({...state.events[i], ...nEvent})
                }
            })
        },
        clearEvents(state, {unitId} = {}) {
            if (unitId) {
                state.events = state.events.filter(e => (e.unit_id || e.object_id) != unitId)
                state.events_index = state.events_index.filter(i => i.unitId != unitId)
            } else {
                state.events = [];
                state.events_index = [];
            }
        },
        setLastVisitEvents(state, time) {
            state.lastVisitEvents = time
        },
        setLastVisitAlerts(state, time) {
            state.lastVisitAlerts = time
        },
    },
    getters: {
        getLastVisitEvents(state, getters) {
            return state.lastVisitCommands || (localStorage.getItem(getters.getUserStorageKey + '.events.lastVisit') * 1)
        },
        getLastVisitAlerts(state, getters) {
            return state.lastVisitAlerts || (localStorage.getItem(getters.getUserStorageKey + '.alerts.lastVisit') * 1)
        },
        getNewEventsCount(state, getters) {
            let lastVisit = getters.getLastVisitEvents
            if (getters.getTimeToday > lastVisit) lastVisit = getters.getTimeToday
            return state.events.filter(e => (e.time?.utc > lastVisit) && !alertsTypes.includes(e['sub-type'])).length
        },
        getNewAlertsCount(state, getters) {
            let lastVisit = getters.getLastVisitAlerts
            if (getters.getTimeToday > lastVisit) lastVisit = getters.getTimeToday
            let event = state.events.filter(e => (e.time?.utc > lastVisit) && alertsTypes.includes(e['sub-type'])).length
            return event;
        },
        getEventsIndex(state) {
            return state.events_index
        },
        getEvents(state) {
            return state.events
        },
        getEventsI18nMessages(state) {
            return state.events
                .map((eventsTextByXid, event) => {
                    let message = event?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = event?.message[match[1]] || ''
                            let translateKey = 'message.' + 'events' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    return {type: event.type, xid: event.xid, message};
                })
        },
        getEventsI18nMessagesByXid(state) {
            return state.events
                .reduce((eventsTextByXid, event) => {
                    let message = event?.message?.msg;
                    if (message) {
                        let matches = message.matchAll(/\$t{([\w]+)}/gi);
                        Array.from(matches).forEach(match => {
                            let str = event?.message[match[1]] || ''
                            let translateKey = 'message.' + 'events' + '.' + str
                            str = i18n.global.te(translateKey) ? i18n.global.t(translateKey) : str
                            message = message.replace(match[0], str);
                        })
                    }
                    eventsTextByXid[event.xid] = message;// || i18n.global.t('message.Unknown')//???
                    return eventsTextByXid;
                }, {})
        },
        getEventsLastTimeByUnitIds(state) {
            return state.events
                //.filter(e => e?.time?.utc >= getters.getTimeToday)
                .reduce((timeByUnitIds, event) => {
                    timeByUnitIds[event.unit_id] = event?.time?.utc > timeByUnitIds[event.unit_id] ? event?.time?.utc : timeByUnitIds[event.unit_id]
                    return timeByUnitIds
                }, {})
        },
    }
}
